/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutOnboardingRouteImport } from './routes/_layout/onboarding'
import { Route as LayoutAppRouteImport } from './routes/_layout/_app'
import { Route as LayoutAppIndexRouteImport } from './routes/_layout/_app/index'
import { Route as LayoutAppSettingsRouteImport } from './routes/_layout/_app/settings'
import { Route as LayoutAppDashboardRouteImport } from './routes/_layout/_app/dashboard'
import { Route as LayoutAppSettingsIndexRouteImport } from './routes/_layout/_app/settings.index'
import { Route as LayoutAppSettingsJobsRouteImport } from './routes/_layout/_app/settings.jobs'
import { Route as LayoutAppSettingsDocumentsRouteImport } from './routes/_layout/_app/settings.documents'
import { Route as LayoutAppSettingsCompanyRouteImport } from './routes/_layout/_app/settings.company'
import { Route as LayoutAppReferralsIdRouteImport } from './routes/_layout/_app/referrals.$id'
import { Route as LayoutAppOtherDocumentsIdRouteImport } from './routes/_layout/_app/other-documents.$id'
import { Route as LayoutAppEditorIdRouteImport } from './routes/_layout/_app/editor.$id'
import { Route as LayoutAppContractsIdRouteImport } from './routes/_layout/_app/contracts.$id'
import { Route as LayoutAppAnnexesIdRouteImport } from './routes/_layout/_app/annexes.$id'
import { Route as LayoutAppSettingsDocumentsIndexRouteImport } from './routes/_layout/_app/settings.documents.index'
import { Route as LayoutAppSettingsDocumentsSplatRouteImport } from './routes/_layout/_app/settings.documents.$'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutOnboardingRoute = LayoutOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAppRoute = LayoutAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAppIndexRoute = LayoutAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppSettingsRoute = LayoutAppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppDashboardRoute = LayoutAppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppSettingsIndexRoute = LayoutAppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutAppSettingsRoute,
} as any)
const LayoutAppSettingsJobsRoute = LayoutAppSettingsJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => LayoutAppSettingsRoute,
} as any)
const LayoutAppSettingsDocumentsRoute =
  LayoutAppSettingsDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => LayoutAppSettingsRoute,
  } as any)
const LayoutAppSettingsCompanyRoute =
  LayoutAppSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => LayoutAppSettingsRoute,
  } as any)
const LayoutAppReferralsIdRoute = LayoutAppReferralsIdRouteImport.update({
  id: '/referrals/$id',
  path: '/referrals/$id',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppOtherDocumentsIdRoute =
  LayoutAppOtherDocumentsIdRouteImport.update({
    id: '/other-documents/$id',
    path: '/other-documents/$id',
    getParentRoute: () => LayoutAppRoute,
  } as any)
const LayoutAppEditorIdRoute = LayoutAppEditorIdRouteImport.update({
  id: '/editor/$id',
  path: '/editor/$id',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppContractsIdRoute = LayoutAppContractsIdRouteImport.update({
  id: '/contracts/$id',
  path: '/contracts/$id',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppAnnexesIdRoute = LayoutAppAnnexesIdRouteImport.update({
  id: '/annexes/$id',
  path: '/annexes/$id',
  getParentRoute: () => LayoutAppRoute,
} as any)
const LayoutAppSettingsDocumentsIndexRoute =
  LayoutAppSettingsDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutAppSettingsDocumentsRoute,
  } as any)
const LayoutAppSettingsDocumentsSplatRoute =
  LayoutAppSettingsDocumentsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => LayoutAppSettingsDocumentsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutAppIndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof LayoutOnboardingRoute
  '/dashboard': typeof LayoutAppDashboardRoute
  '/settings': typeof LayoutAppSettingsRouteWithChildren
  '/annexes/$id': typeof LayoutAppAnnexesIdRoute
  '/contracts/$id': typeof LayoutAppContractsIdRoute
  '/editor/$id': typeof LayoutAppEditorIdRoute
  '/other-documents/$id': typeof LayoutAppOtherDocumentsIdRoute
  '/referrals/$id': typeof LayoutAppReferralsIdRoute
  '/settings/company': typeof LayoutAppSettingsCompanyRoute
  '/settings/documents': typeof LayoutAppSettingsDocumentsRouteWithChildren
  '/settings/jobs': typeof LayoutAppSettingsJobsRoute
  '/settings/': typeof LayoutAppSettingsIndexRoute
  '/settings/documents/$': typeof LayoutAppSettingsDocumentsSplatRoute
  '/settings/documents/': typeof LayoutAppSettingsDocumentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LayoutAppIndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof LayoutOnboardingRoute
  '/dashboard': typeof LayoutAppDashboardRoute
  '/annexes/$id': typeof LayoutAppAnnexesIdRoute
  '/contracts/$id': typeof LayoutAppContractsIdRoute
  '/editor/$id': typeof LayoutAppEditorIdRoute
  '/other-documents/$id': typeof LayoutAppOtherDocumentsIdRoute
  '/referrals/$id': typeof LayoutAppReferralsIdRoute
  '/settings/company': typeof LayoutAppSettingsCompanyRoute
  '/settings/jobs': typeof LayoutAppSettingsJobsRoute
  '/settings': typeof LayoutAppSettingsIndexRoute
  '/settings/documents/$': typeof LayoutAppSettingsDocumentsSplatRoute
  '/settings/documents': typeof LayoutAppSettingsDocumentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_layout/_app': typeof LayoutAppRouteWithChildren
  '/_layout/onboarding': typeof LayoutOnboardingRoute
  '/_layout/_app/dashboard': typeof LayoutAppDashboardRoute
  '/_layout/_app/settings': typeof LayoutAppSettingsRouteWithChildren
  '/_layout/_app/': typeof LayoutAppIndexRoute
  '/_layout/_app/annexes/$id': typeof LayoutAppAnnexesIdRoute
  '/_layout/_app/contracts/$id': typeof LayoutAppContractsIdRoute
  '/_layout/_app/editor/$id': typeof LayoutAppEditorIdRoute
  '/_layout/_app/other-documents/$id': typeof LayoutAppOtherDocumentsIdRoute
  '/_layout/_app/referrals/$id': typeof LayoutAppReferralsIdRoute
  '/_layout/_app/settings/company': typeof LayoutAppSettingsCompanyRoute
  '/_layout/_app/settings/documents': typeof LayoutAppSettingsDocumentsRouteWithChildren
  '/_layout/_app/settings/jobs': typeof LayoutAppSettingsJobsRoute
  '/_layout/_app/settings/': typeof LayoutAppSettingsIndexRoute
  '/_layout/_app/settings/documents/$': typeof LayoutAppSettingsDocumentsSplatRoute
  '/_layout/_app/settings/documents/': typeof LayoutAppSettingsDocumentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/login'
    | '/onboarding'
    | '/dashboard'
    | '/settings'
    | '/annexes/$id'
    | '/contracts/$id'
    | '/editor/$id'
    | '/other-documents/$id'
    | '/referrals/$id'
    | '/settings/company'
    | '/settings/documents'
    | '/settings/jobs'
    | '/settings/'
    | '/settings/documents/$'
    | '/settings/documents/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/onboarding'
    | '/dashboard'
    | '/annexes/$id'
    | '/contracts/$id'
    | '/editor/$id'
    | '/other-documents/$id'
    | '/referrals/$id'
    | '/settings/company'
    | '/settings/jobs'
    | '/settings'
    | '/settings/documents/$'
    | '/settings/documents'
  id:
    | '__root__'
    | '/_layout'
    | '/callback'
    | '/login'
    | '/_layout/_app'
    | '/_layout/onboarding'
    | '/_layout/_app/dashboard'
    | '/_layout/_app/settings'
    | '/_layout/_app/'
    | '/_layout/_app/annexes/$id'
    | '/_layout/_app/contracts/$id'
    | '/_layout/_app/editor/$id'
    | '/_layout/_app/other-documents/$id'
    | '/_layout/_app/referrals/$id'
    | '/_layout/_app/settings/company'
    | '/_layout/_app/settings/documents'
    | '/_layout/_app/settings/jobs'
    | '/_layout/_app/settings/'
    | '/_layout/_app/settings/documents/$'
    | '/_layout/_app/settings/documents/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/onboarding': {
      id: '/_layout/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof LayoutOnboardingRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/_app': {
      id: '/_layout/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutAppRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/_app/': {
      id: '/_layout/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutAppIndexRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/settings': {
      id: '/_layout/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutAppSettingsRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/dashboard': {
      id: '/_layout/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutAppDashboardRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/settings/': {
      id: '/_layout/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof LayoutAppSettingsIndexRouteImport
      parentRoute: typeof LayoutAppSettingsRoute
    }
    '/_layout/_app/settings/jobs': {
      id: '/_layout/_app/settings/jobs'
      path: '/jobs'
      fullPath: '/settings/jobs'
      preLoaderRoute: typeof LayoutAppSettingsJobsRouteImport
      parentRoute: typeof LayoutAppSettingsRoute
    }
    '/_layout/_app/settings/documents': {
      id: '/_layout/_app/settings/documents'
      path: '/documents'
      fullPath: '/settings/documents'
      preLoaderRoute: typeof LayoutAppSettingsDocumentsRouteImport
      parentRoute: typeof LayoutAppSettingsRoute
    }
    '/_layout/_app/settings/company': {
      id: '/_layout/_app/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof LayoutAppSettingsCompanyRouteImport
      parentRoute: typeof LayoutAppSettingsRoute
    }
    '/_layout/_app/referrals/$id': {
      id: '/_layout/_app/referrals/$id'
      path: '/referrals/$id'
      fullPath: '/referrals/$id'
      preLoaderRoute: typeof LayoutAppReferralsIdRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/other-documents/$id': {
      id: '/_layout/_app/other-documents/$id'
      path: '/other-documents/$id'
      fullPath: '/other-documents/$id'
      preLoaderRoute: typeof LayoutAppOtherDocumentsIdRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/editor/$id': {
      id: '/_layout/_app/editor/$id'
      path: '/editor/$id'
      fullPath: '/editor/$id'
      preLoaderRoute: typeof LayoutAppEditorIdRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/contracts/$id': {
      id: '/_layout/_app/contracts/$id'
      path: '/contracts/$id'
      fullPath: '/contracts/$id'
      preLoaderRoute: typeof LayoutAppContractsIdRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/annexes/$id': {
      id: '/_layout/_app/annexes/$id'
      path: '/annexes/$id'
      fullPath: '/annexes/$id'
      preLoaderRoute: typeof LayoutAppAnnexesIdRouteImport
      parentRoute: typeof LayoutAppRoute
    }
    '/_layout/_app/settings/documents/': {
      id: '/_layout/_app/settings/documents/'
      path: '/'
      fullPath: '/settings/documents/'
      preLoaderRoute: typeof LayoutAppSettingsDocumentsIndexRouteImport
      parentRoute: typeof LayoutAppSettingsDocumentsRoute
    }
    '/_layout/_app/settings/documents/$': {
      id: '/_layout/_app/settings/documents/$'
      path: '/$'
      fullPath: '/settings/documents/$'
      preLoaderRoute: typeof LayoutAppSettingsDocumentsSplatRouteImport
      parentRoute: typeof LayoutAppSettingsDocumentsRoute
    }
  }
}

interface LayoutAppSettingsDocumentsRouteChildren {
  LayoutAppSettingsDocumentsSplatRoute: typeof LayoutAppSettingsDocumentsSplatRoute
  LayoutAppSettingsDocumentsIndexRoute: typeof LayoutAppSettingsDocumentsIndexRoute
}

const LayoutAppSettingsDocumentsRouteChildren: LayoutAppSettingsDocumentsRouteChildren =
  {
    LayoutAppSettingsDocumentsSplatRoute: LayoutAppSettingsDocumentsSplatRoute,
    LayoutAppSettingsDocumentsIndexRoute: LayoutAppSettingsDocumentsIndexRoute,
  }

const LayoutAppSettingsDocumentsRouteWithChildren =
  LayoutAppSettingsDocumentsRoute._addFileChildren(
    LayoutAppSettingsDocumentsRouteChildren,
  )

interface LayoutAppSettingsRouteChildren {
  LayoutAppSettingsCompanyRoute: typeof LayoutAppSettingsCompanyRoute
  LayoutAppSettingsDocumentsRoute: typeof LayoutAppSettingsDocumentsRouteWithChildren
  LayoutAppSettingsJobsRoute: typeof LayoutAppSettingsJobsRoute
  LayoutAppSettingsIndexRoute: typeof LayoutAppSettingsIndexRoute
}

const LayoutAppSettingsRouteChildren: LayoutAppSettingsRouteChildren = {
  LayoutAppSettingsCompanyRoute: LayoutAppSettingsCompanyRoute,
  LayoutAppSettingsDocumentsRoute: LayoutAppSettingsDocumentsRouteWithChildren,
  LayoutAppSettingsJobsRoute: LayoutAppSettingsJobsRoute,
  LayoutAppSettingsIndexRoute: LayoutAppSettingsIndexRoute,
}

const LayoutAppSettingsRouteWithChildren =
  LayoutAppSettingsRoute._addFileChildren(LayoutAppSettingsRouteChildren)

interface LayoutAppRouteChildren {
  LayoutAppDashboardRoute: typeof LayoutAppDashboardRoute
  LayoutAppSettingsRoute: typeof LayoutAppSettingsRouteWithChildren
  LayoutAppIndexRoute: typeof LayoutAppIndexRoute
  LayoutAppAnnexesIdRoute: typeof LayoutAppAnnexesIdRoute
  LayoutAppContractsIdRoute: typeof LayoutAppContractsIdRoute
  LayoutAppEditorIdRoute: typeof LayoutAppEditorIdRoute
  LayoutAppOtherDocumentsIdRoute: typeof LayoutAppOtherDocumentsIdRoute
  LayoutAppReferralsIdRoute: typeof LayoutAppReferralsIdRoute
}

const LayoutAppRouteChildren: LayoutAppRouteChildren = {
  LayoutAppDashboardRoute: LayoutAppDashboardRoute,
  LayoutAppSettingsRoute: LayoutAppSettingsRouteWithChildren,
  LayoutAppIndexRoute: LayoutAppIndexRoute,
  LayoutAppAnnexesIdRoute: LayoutAppAnnexesIdRoute,
  LayoutAppContractsIdRoute: LayoutAppContractsIdRoute,
  LayoutAppEditorIdRoute: LayoutAppEditorIdRoute,
  LayoutAppOtherDocumentsIdRoute: LayoutAppOtherDocumentsIdRoute,
  LayoutAppReferralsIdRoute: LayoutAppReferralsIdRoute,
}

const LayoutAppRouteWithChildren = LayoutAppRoute._addFileChildren(
  LayoutAppRouteChildren,
)

interface LayoutRouteChildren {
  LayoutAppRoute: typeof LayoutAppRouteWithChildren
  LayoutOnboardingRoute: typeof LayoutOnboardingRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAppRoute: LayoutAppRouteWithChildren,
  LayoutOnboardingRoute: LayoutOnboardingRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
